import { render, staticRenderFns } from "./glas-in-lood.vue?vue&type=template&id=6c5c0188&scoped=true"
import script from "./glas-in-lood.vue?vue&type=script&lang=js"
export * from "./glas-in-lood.vue?vue&type=script&lang=js"
import style0 from "./glas-in-lood.vue?vue&type=style&index=0&id=6c5c0188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c0188",
  null
  
)

export default component.exports